import { render, staticRenderFns } from "./GenericName.vue?vue&type=template&id=0c977cec&scoped=true"
import script from "./GenericName.vue?vue&type=script&lang=js"
export * from "./GenericName.vue?vue&type=script&lang=js"
import style0 from "./GenericName.vue?vue&type=style&index=0&id=0c977cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c977cec",
  null
  
)

export default component.exports